export default __webpack_public_path__ + "static/media/bsc-logo.02bd3a33.svg";